import React from "react";

/**
 * Small stat tile used inside HealthCard / AutoSyncStatusCard / ApiErrorsCard
 * to display a labelled numeric value with an optional danger colour.
 */
export const Stat: React.FC<{ label: string; value: string; testId?: string; mono?: boolean; danger?: boolean }> = ({
  label, value, testId, mono, danger,
}) => (
  <div
    className={`rounded-md border px-3 py-2 ${
      danger
        ? "border-red-200 bg-red-50"
        : "border-[color:var(--sg-border)] bg-[color:var(--sg-muted-bg)]"
    }`}
  >
    <div className="text-[10px] uppercase tracking-wide text-[color:var(--sg-muted)]">
      {label}
    </div>
    <div
      data-testid={testId}
      className={`text-sm mt-0.5 ${mono ? "font-mono" : ""} ${
        danger ? "text-red-700 font-semibold" : "text-[color:var(--sg-fg)]"
      }`}
    >
      {value}
    </div>
  </div>
);
